<template>
    <div
         data-cy="indexItem-item"
        :class="
            'w-100 d-flex justify-start chapter-content text-left pl-5 pr-5 pt-3 pb-3 mb-2 ' +
            (active ? 'chapter-active' : 'chapter-text')
        "
        @click="setChapter"
    >
        <span
            >{{ $t('bookReading.chapter') }} {{ chapter_data.chapterNumber }}.
            {{ chapter_data.chapterTitle }}</span
        >
    </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'

export default {
    props: {
        chapter_data: { type: Object, default: null },
        active: { type: Boolean, default: false },
    },
    computed: {
        ...mapState({
            currentStage: (state) => state.bookReading.currentStage,
            currentPage: (state) => state.bookReading.currentPage,
            currentChapter: (state) => state.bookReading.currentChapter,
            currentChapterData: (state) => state.bookReading.currentChapterData,
        }),
    },
    methods: {
        ...mapActions('bookReading', [
            'setCurrentPage',
            'setCurrentChapter',
            'setCurrentChapterData',
        ]),
        setChapter() {
            window.scrollTo(0, 0)
            let bookPage = document.querySelector(`#bookpage_${this.currentPage}`)
            if (bookPage) bookPage.style.display = 'none'

            let chapterHtml = document.querySelector(`#chapter_${this.currentChapter}`)
            if (chapterHtml) chapterHtml.style.display = 'none'

            this.setCurrentChapter(this.chapter_data.chapterNumber)
            this.setCurrentPage(this.chapter_data.structInitialPage)

            chapterHtml = document.querySelector(`#chapter_${this.currentChapter}`)
            if (chapterHtml) chapterHtml.style.display = 'block'

            const currentPage = document.querySelector(`.current-page`)
            if(currentPage) currentPage.classList.toggle('current-page')

            bookPage = document.querySelector(`#bookpage_${this.currentPage}`)
            if (bookPage) {
                bookPage.style.display = 'flex'
                bookPage.classList.toggle('current-page')
            }

            this.setCurrentChapterData(this.chapter_data)
        },
    },
}
</script>

<style lang="scss">
.chapter-content {
    background: #EEECF8;
    border-radius: 8px;
    &:hover {
        cursor: pointer;
        background-image: linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1));
    }
    &.chapter-active,
    &.chapter-active:hover {
        background: linear-gradient(147.2deg, #A295DA 4.28%, #7764CA 33.93%, #6857B2 62.04%, #514585 95.25%);
        box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.1);
        border-radius: 8px;
        color: white !important;
    }
}
.chapter-text {
    background: #EEECF8;;
    color: #514773;
}

</style>
